import React from 'react';
import { GraduationCap } from 'lucide-react';
import RoleDashboard from './dashboards/RoleDashboard';

// The "AI Adoption" landing. Renders the role-appropriate designed dashboard
// (champion company view, owner admin view, or consultant portfolio). The
// per-role sub-views (My Readiness, Onboarding, My Department, Roster,
// Use-Case Registry…) are now top-level sidebar items, not tabs here.
const AaiWorkspace: React.FC = () => (
  <div className="max-w-5xl mx-auto px-4 py-6">
    <div className="flex items-center gap-2 mb-1">
      <GraduationCap size={22} className="text-brand-500" />
      <h1 className="text-2xl font-semibold text-gray-900">AI Adoption</h1>
    </div>
    <p className="text-sm text-gray-500 mb-6">Where your company is with AI, and what to do next.</p>
    <RoleDashboard />
  </div>
);

export default AaiWorkspace;
